/** regionId is the shop search's id for the state. Names stay German: they are proper nouns. */
export const FEDERAL_STATES = [
    { code: "BW", name: "Baden-Württemberg", regionId: "55" },
    { code: "BY", name: "Bayern", regionId: "53" },
    { code: "BE", name: "Berlin", regionId: "60" },
    { code: "BB", name: "Brandenburg", regionId: "58" },
    { code: "HB", name: "Bremen", regionId: "61" },
    { code: "HH", name: "Hamburg", regionId: "62" },
    { code: "HE", name: "Hessen", regionId: "59" },
    { code: "MV", name: "Mecklenburg-Vorpommern", regionId: "64" },
    { code: "NI", name: "Niedersachsen", regionId: "65" },
    { code: "NW", name: "Nordrhein-Westfalen", regionId: "57" },
    { code: "RP", name: "Rheinland-Pfalz", regionId: "54" },
    { code: "SL", name: "Saarland", regionId: "66" },
    { code: "SN", name: "Sachsen", regionId: "63" },
    { code: "ST", name: "Sachsen-Anhalt", regionId: "67" },
    { code: "SH", name: "Schleswig-Holstein", regionId: "56" },
    { code: "TH", name: "Thüringen", regionId: "68" },
] as const;

export type FederalStateCode = (typeof FEDERAL_STATES)[number]["code"];

/** Austrian-only volumes carry this instead of a federal state, so only NO_FEDERAL_STATE offers them. */
export const AUSTRIA = "AT";

/** The teacher skipped the state: every book is shown. */
export const NO_FEDERAL_STATE = "none";

export type FederalStateChoice = FederalStateCode | typeof NO_FEDERAL_STATE;

export const isFederalStateChoice = (value: unknown): value is FederalStateChoice =>
    value === NO_FEDERAL_STATE || FEDERAL_STATES.some((state) => state.code === value);
